import { fetchUserAttributes, updateUserAttribute } from "aws-amplify/auth"

export type AttributeKeys = "custom:isOnboardedToSmartKb" | "custom:language"

export const getAttribute = async (key: AttributeKeys): Promise<boolean> => {
  const userAttributes = await fetchUserAttributes()
  const isOnboardedAttribute = userAttributes[key] === "true"
  return isOnboardedAttribute
}

export const updateAttribute = async (
  key: AttributeKeys,
  value: string,
): Promise<void> => {
  await updateUserAttribute({
    userAttribute: {
      attributeKey: key,
      value,
    },
  })
}
